import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RegisterPushTokenRequest } from '@/app/shared/models';
import { AppConfig } from '../config/app-config';

@Injectable({ providedIn: 'root' })
export class PushTokensApi {
  private readonly baseUrl = `${AppConfig.apiBaseUrl}/api/push-tokens`;

  constructor(private readonly http: HttpClient) {}

  registerPushToken(request: RegisterPushTokenRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/register`, request);
  }
}
